import { HttpErrorResponse, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { BehaviorSubject, catchError, concatMap, filter, finalize, map, of, ReplaySubject, share, tap } from 'rxjs'

import { IQuestion } from '../model/question'
import { SurveyResponse } from '../model/survey'
import { AuthenticatedRestService } from './auth-rest.service'
import { isResponse, toData } from './rest'

@Injectable({
  providedIn: 'root',
})
export class SurveyService extends AuthenticatedRestService {
  loading$ = new BehaviorSubject<boolean>(false)
  questionsParams = new ReplaySubject<Record<string, any>>(1)
  surveyResponseParams = new ReplaySubject<Record<string, any>>(1)

  questions$ = this.questionsParams.pipe(
    map((object) => new HttpParams({ fromObject: object })),
    tap(() => this.loading$.next(true)),
    concatMap((params) =>
      this.get<IQuestion[]>(`/clinics/${this.clinicService.clinicId}/survey-questions`, params).pipe(
        catchError((error: HttpErrorResponse) => of(error)),
        finalize(() => this.loading$.next(false)),
      ),
    ),
    share(),
  )

  questionsSuccess$ = this.questions$.pipe(
    filter(isResponse),
    map(toData),
    share(),
  )

  surveyResponse$ = this.surveyResponseParams.pipe(
    tap(() => this.loading$.next(true)),
    concatMap((params) =>
      this.get<SurveyResponse>(`/appointments/${params['appointmentId']}/survey-response`).pipe(
        catchError((error: HttpErrorResponse) => of(error)),
        finalize(() => this.loading$.next(false)),
      ),
    ),
    share(),
  )

  surveyResponseSuccess$ = this.surveyResponse$.pipe(
    filter((response) => !!response && isResponse(response)),
    map(toData),
  )
}
